import useVideoCallSocket from "@customHooks/video-call/use-videocall-socket";
import { BasicVideoCallI, VideoCallReciveI } from "@interfaces/videocall/videocall";
import { VideoCallSocketContext } from '@contexts/videocall';
import { setCleanVideoCall, setCurrentVideoCall } from "@redux/slices/video-call/video-call.slice";
import { setVideoAlert, setVideoCallInProcess } from "@redux/slices/video-call/videoCall-alert.slice";
import { RootState } from "@redux/store";
import { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import VideoAlert from "./VideoAlert";



export default function VideoNotificationContainer() {
    const session = useSelector((state: RootState) => state.session)
    const { emitSocketVideoEvent } = useVideoCallSocket();  
    const { socketVideo } = useContext(VideoCallSocketContext)
    const [ videoCall, setVideoCall ] = useState<VideoCallReciveI>();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [leaveUser, setLeaveUser] = useState<BasicVideoCallI>();
    const currentVideoCall = useSelector((state: RootState) => state.videoCall)
    const history = useNavigate();
    const dispatch = useDispatch();
    const videoAlert = useSelector((state: RootState) => state.videoAlert)


    const leave = useCallback(async (data: VideoCallReciveI | undefined) => {
        // toggle('incomingCall', false);
        //Change this function to Leave video Call
        // leaveCall(audioTrack)
        const listener = {
            username: null,
            newVideoCall: false
        }
        dispatch(
            setVideoAlert(listener)
        );
        if(data){
            emitSocketVideoEvent("leave_call", {
                name: data.name,
                id: data.id,
                token: data.token,
                room: data.room,
                idEmit: data.idEmit,
            });
            
            dispatch(setVideoCallInProcess({videoCallInProgress: false}))
            setVideoCall(undefined)
            dispatch(setCleanVideoCall())
            setLeaveUser(undefined)
            // setAudioTrack(undefined)
            setOpenModal(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, emitSocketVideoEvent]);

    const join = () => {
        dispatch( setVideoCallInProcess({videoCallInProgress: true}) )
        setOpenModal(false);
    }

    useEffect(() => {
        if(socketVideo){
            socketVideo.on("receive_call", (data: VideoCallReciveI) => {
                // addNotification({
                //     title: 'Tienes una llamada',
                //     subtitle: 'SaludProx',
                //     message: 'Alguien te esta llamando',
                //     theme: 'light',
                //     duration: 10000,
                //     onClick: goChat,
                //     closeButton: "Cerrar",
                //     native: true // when using native, your OS will handle theming.
                // });
                // toggle('incomingCall', true);
                if(currentVideoCall && videoAlert.videoAlert.videoCallInProgress ){
                    emitSocketVideoEvent("leave_call", {
                        name: data.name,
                        id: data.id,
                        token: data.token,
                        room: data.room,
                        idEmit: data.idEmit,
                    });
                }else{
                    socketVideo.emit('precall', {
                        room: data.room,
                    });
                    setVideoCall(data)
                    setOpenModal(true);
                    const listener = {
                        username: data.nameEmit,
                        newVideoCall: true
                    } 
                    dispatch(
                        setVideoAlert(listener)
                    );
                    dispatch(setCurrentVideoCall({
                        nameEmit: String(data.nameEmit),
                        name: String(data.name),
                        username:String(data.username),
                        id: String(data.id),
                        idEmit: String(data.idEmit),
                        token: String(data.token),
                        room: `${data.room}`,
                    }));
                }
            });
            socketVideo.on("leave", (data: BasicVideoCallI) => {
                if(data.id === currentVideoCall.videoCall?.id){
                    leave(currentVideoCall.videoCall as VideoCallReciveI)
                }
                    // setLeaveUser(data)
            });
            socketVideo.on("users_in_call", (data: string[]) => {
                if (data) {
                    // setVideocallInProcess(true);
                    console.log("users_in_call");
                    // dispatch( setVideoCallInProcess({videoCallInProgress: true}))
                    // dispatch( setVideoCallInProcess({videoCallInProgress: false}))
                } else {
                    // setVideocallInProcess(false);
                    dispatch(setVideoCallInProcess({videoCallInProgress: false}))
                }
            });
        }

        return () => {
            if(socketVideo) {
                socketVideo.removeAllListeners("receive_call");
                socketVideo.removeAllListeners("leave");
                socketVideo.removeAllListeners("users_in_call");
            }
        }
    })

    return(
        <VideoAlert
            open={openModal}
            declineCall={() => leave(videoCall)}
            callInProsess={false}
            videoCall={videoCall}
            reciveCall={() => join()}
            leaveUser={undefined}
        />
    )
}